// When the Seller Forecast tab lets sellers accept or override the model
// forecast, and why it is locked otherwise.

// Last day of the month (inclusive) on which sellers can still accept or
// override the freshly-issued forecast. After this day editing locks until
// the next month's predictions are issued. Bump this if the cut-off changes.
export const FORECAST_EDIT_CUTOFF_DAY = 17;

const ordinal = (day) =>
  day === 1 ? "st" : day === 2 ? "nd" : day === 3 ? "rd" : "th";

export const EDITING_CLOSED_MESSAGE = `Editing is no longer available this month (cut-off is the ${FORECAST_EDIT_CUTOFF_DAY}${ordinal(
  FORECAST_EDIT_CUTOFF_DAY
)}). New predictions will be issued at the start of next month.`;

export const AWAITING_FORECAST_MESSAGE =
  "This month's model forecast hasn't been published yet. Editing opens once it is.";

// "YYYY-MM" of a Date, in the browser's local time like the rest of the tab.
export const monthKeyOf = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

// Latest `calculated_at` ("YYYY-MM-DD") across the store's predicted units,
// or "" when no ASIN has a model forecast. demand_forecast_results stamps
// every monthly run with the 1st of its month, so this is the month the
// forecast on screen was issued in, whatever day the rows actually landed.
export const getLatestForecastDate = (predictedUnits) =>
  (predictedUnits || []).reduce(
    (latest, unit) =>
      unit?.calculated_at && unit.calculated_at > latest
        ? unit.calculated_at
        : latest,
    ""
  );

// Editing state for the month, as { status, message }:
//  - "closed":  past the cut-off day; reopens with next month's forecast.
//  - "waiting": the forecast on screen was issued in an earlier month, i.e.
//               demand_forecast_results has not been refreshed for this
//               store yet. Reviews would be recorded against the stale
//               numbers (their forecast_date is the forecast's calculated_at)
//               and silently turn pending again once the new run lands, so
//               editing stays locked until it does.
//  - "open":    this month's forecast is in and the cut-off hasn't passed.
// A store with no model forecast at all is not gated on publication: it can
// only ever enter manual forecasts, so it just follows the calendar.
export const getForecastEditWindow = (latestForecastDate, now = new Date()) => {
  if (now.getDate() > FORECAST_EDIT_CUTOFF_DAY) {
    return { status: "closed", message: EDITING_CLOSED_MESSAGE };
  }
  if (latestForecastDate && latestForecastDate.slice(0, 7) < monthKeyOf(now)) {
    return { status: "waiting", message: AWAITING_FORECAST_MESSAGE };
  }
  return { status: "open", message: "" };
};
